<template>
  <b-overlay :show="isLoading" rounded="sm">
    <b-card class="mb-0">
      <div
        class="w-100 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between"
      >
        <h1 class="mb-2">لیست دسته بندی های سوالات متداول</h1>
        <b-button variant="primary" @click="renderNewCategoryModal">
          <span class="text-nowrap">+ ساخت دسته بندی جدید</span>
        </b-button>
      </div>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <b-col cols="12">
            <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="categoriesList"
              responsive
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
            >
              <template #cell(actions)="data">
                <div
                  class="w-100 d-flex align-items-center justify-content-around"
                >
                  <button
                    class="btn btn-transparent"
                    type="button"
                    @click="renderEditCategoryModal(data.item)"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="20"
                      class="text-primary"
                    />
                  </button>
                  <button
                    class="btn btn-transparent"
                    type="button"
                    @click="renderDeleteCategoryModal(data.item)"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      size="20"
                      class="text-danger"
                    />
                  </button>
                </div>
              </template>
            </b-table>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="pageNumber"
              :total-rows="totalCount"
              :per-page="count"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <!-- Category Create Modal Start -->
    <faq-category-create-modal
      @reFetch="getAllFaqCategories"
    ></faq-category-create-modal>
    <!-- Category Create Modal End -->

    <!-- Category Edit Modal Start -->
    <template v-if="tempCategory">
      <faq-category-edit-modal
        :categoryDetails="tempCategory"
        @reFetch="getAllFaqCategories"
      ></faq-category-edit-modal>
    </template>
    <!-- Category Edit Modal End -->

    <!-- Category Delete Modal Start -->
    <template v-if="tempCategory">
      <b-modal
        :title="`حذف دسته بندی ${tempCategory.title}`"
        id="modal-faq-category-delete"
        centered
        ok-title="حذف"
        cancel-title="بستن"
        @ok="deleteASingleFaqCategory(tempCategory.id)"
      >
        <p>آیا از حذف دسته بندی {{ tempCategory.title }} اطمینان دارید؟</p>
      </b-modal>
    </template>
    <!-- Category Delete Modal End -->
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getAllFaqCategories();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getAllFaqCategories();
      },
    },
  },
  data() {
    return {
      pageNumber: 1,
      count: 10,
      totalCount: null,
      categoriesList: null,
      isLoading: false,
      myTableColumns: [
        { key: "id", label: "شناسه" },
        { key: "title", label: "عنوان دسته بندی" },
        { key: "actions", label: "عملیات" },
      ],
      tempCategory: null,
    };
  },
  methods: {
    async getAllFaqCategories() {
      this.tempCategory = null;
      try {
        this.isLoading = true;
        const _this = this;
        let faqCategoryGetAllRequest = new FaqCategoryGetAllRequest(_this);
        faqCategoryGetAllRequest.setParams({
          pageNumber: _this.pageNumber,
          count: _this.count,
        });
        await faqCategoryGetAllRequest.fetch((res) => {
          _this.categoriesList = res.items;
          _this.totalCount = res.totalCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getASingleFaqCategory(id) {
      try {
        this.isLoading = true;
        const _this = this;
        let faqGetSingleRequest = new FaqGetSingleRequest(_this);
        faqGetSingleRequest.setRequestParam({
          id,
        });
        await faqGetSingleRequest.fetch((res) => {
          _this.tempCategory = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async deleteASingleFaqCategory(id) {
      try {
        this.isLoading = true;
        const _this = this;
        let faqCategoryDeleteRequest = new FaqCategoryDeleteRequest(_this);
        faqCategoryDeleteRequest.setParams({ id });
        await faqCategoryDeleteRequest.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "دسته بندی با موفقیت حذف شد",
              },
            });
            this.$bvModal.hide("modal-faq-category-delete");
            _this.getAllFaqCategories();
          } else {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "خطا در حذف دسته بندی",
                icon: "XIcon",
                variant: "danger",
                text: res.errorMessage,
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async renderEditCategoryModal(category) {
      await this.getASingleFaqCategory(category.id);
      this.$nextTick(() => {
        this.$bvModal.show("modal-faq-category-edit");
      });
    },
    renderDeleteCategoryModal(category) {
      this.tempCategory = category;
      this.$nextTick(() => {
        this.$bvModal.show("modal-faq-category-delete");
      });
    },
    renderNewCategoryModal() {
      this.$bvModal.show("modal-faq-category-create");
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    BFormRow,
    BContainer,
    BFormGroup,
    BFormFile,
    FaqCategoryCreateModal,
    FaqCategoryEditModal,
  },
};
import FaqCategoryCreateModal from "@/@core/utils/FaqCategoryCreateModal.vue";
import FaqCategoryEditModal from "@/@core/utils/FaqCategoryEditModal.vue";
import {
  FaqCategoryGetAllRequest,
  FaqGetSingleRequest,
  FaqCategoryDeleteRequest,
} from "@/libs/Api/FaqCategory/FaqCategoryRequests";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BFormRow,
  BContainer,
  BFormGroup,
  BLink,
  BBadge,
  BDropdown,
  BFormFile,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
</script>
